// src/components/modules/orgChartApi.js
// Org Chart API (Controllers/OrgChartController.cs, tables from OrgChart_Setup.sql)

import { Timesheetapi } from "../../middleware/interceptor";

const who = () => ({
  empid: Number(localStorage.getItem("employee_id")) || 0,
  roleId: Number(localStorage.getItem("emp_role_id")) || 0,
});

const mapPerson = (p) => ({
  id: p.org_emp_id,
  code: p.emp_code || "",
  name: p.name || "",
  email: p.email || "",
  phone: p.phone || "",
  region: p.region || "",
  designation: p.designation || "",
  managerId: p.reporting_to_id ?? null,
  joined: p.date_of_joining || "",
  employeeId: p.employee_id ?? null,
  active: !!p.is_active,
  inactiveDate: p.inactive_date || "",
  status: p.status || "Active",                 // Active | Notice Period | Relieved
  relievingDate: p.relieving_date || "",        // "YYYY-MM-DD" or ""
  sort: p.sort_order || 0,
});

const check = (res, fallback) => {
  const d = res?.data;
  if (d?.status !== 1) throw new Error(d?.message || fallback);
  return d;
};

// { canEdit, people: [...], regions: [...] } — inactive people only come back for Admin / HR
export async function fetchOrgChart() {
  const d = check(
    await Timesheetapi.get("api/OrgChart/List", { params: { ...who(), includeInactive: true } }),
    "Could not load the org chart."
  );
  return { canEdit: !!d.can_edit, people: (d.employees || []).map(mapPerson), regions: d.regions || [] };
}

// person: { id (0 = new), code, name, email, phone, region, designation, managerId, joined: "YYYY-MM-DD",
//          status: "Active" | "Notice Period" | "Relieved", relievingDate: "YYYY-MM-DD" | null }
export async function saveOrgPerson(person) {
  const d = check(
    await Timesheetapi.post("api/OrgChart/Save", {
      ...who(),
      employee: {
        org_emp_id: person.id || 0,
        emp_code: person.code,
        name: person.name,
        email: person.email || null,
        phone: person.phone || null,
        region: person.region || null,
        designation: person.designation || null,
        reporting_to_id: person.managerId || null,
        date_of_joining: person.joined || null,
        status: person.status || "Active",
        relieving_date: person.relievingDate || null,
      },
    }),
    "Could not save."
  );
  return { message: d.message, person: d.employee ? mapPerson(d.employee) : null };
}

// managerId null = top level
export async function moveOrgPerson(id, managerId) {
  return check(
    await Timesheetapi.post("api/OrgChart/Move", { ...who(), org_emp_id: id, manager_id: managerId ?? null }),
    "Could not move."
  ).message;
}

export async function setOrgPersonActive(id, active, date) {
  return check(
    await Timesheetapi.post("api/OrgChart/SetActive", { ...who(), org_emp_id: id, active, date }),
    "Could not save."
  ).message;
}

// "Edit chart" → Save: moves = [{ id, managerId (null = top level) }], saved together (all or nothing)
export async function saveOrgMoves(moves) {
  return check(
    await Timesheetapi.post("api/OrgChart/MoveMany", {
      ...who(),
      moves: moves.map((m) => ({ org_emp_id: m.id, manager_id: m.managerId ?? null })),
    }),
    "Could not save."
  ).message;
}